<template>
    <v-dialog v-model="dialog" max-width="800">
        <v-card class="pa-5">
            <div class="d-flex align-center font-weight-medium mb-4">
                <div>
                    Configure Webhook integration
                    <a :href="`https://coroot.com/docs/coroot-community-edition/alerting/webhook`" target="_blank">
                        <v-icon>mdi-information-outline</v-icon>
                    </a>
                    <v-progress-circular v-if="loading" indeterminate color="green" size="30" />
                </div>
                <v-spacer />
                <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-form ref="form" v-model="valid" :disabled="value === 'del'">
                <!-- eslint-disable vue/no-mutating-props -->
                <div class="subtitle-1">Webhook URL</div>
                <v-text-field v-model="integration.webhook.url" outlined dense :rules="[$validators.notEmpty]" hide-details />

                <v-checkbox v-model="integration.webhook.tls_skip_verify" :disabled="!(integration.webhook.url || '').startsWith('https')" label="Skip TLS verify" hide-details />

                <v-checkbox v-model="basic_auth" label="HTTP basic auth" class="my-2" hide-details />
                <div v-if="basic_auth" class="d-flex gap">
                    <v-text-field outlined dense v-model="integration.webhook.basic_auth.user" label="username" hide-details single-line />
                    <v-text-field v-model="integration.webhook.basic_auth.password" label="password" type="password" outlined dense hide-details single-line />
                </div>

                <v-checkbox v-model="custom_headers" label="Custom HTTP headers" class="my-2" hide-details />
                <template v-if="custom_headers">
                    <div v-for="(h, i) in integration.webhook.custom_headers" :key="i" class="d-flex mb-2 align-center" style="gap: 8px">
                        <v-text-field outlined dense v-model="h.key" label="header" hide-details single-line />
                        <v-text-field outlined dense v-model="h.value" label="value" hide-details single-line />
                        <v-btn @click="integration.webhook.custom_headers.splice(i, 1)" icon small>
                            <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </div>
                    <v-btn color="primary" small @click="integration.webhook.custom_headers.push({ key: '', value: '' })">Add header</v-btn>
                </template>

                <div class="subtitle-1">Incident template</div>
                <v-textarea v-model="integration.webhook.incident_template" outlined dense :rules="[$validators.notEmpty]" />

                <div class="subtitle-1">Deployment template</div>
                <v-textarea v-model="integration.webhook.deployment_template" outlined dense :rules="[$validators.notEmpty]" />

                <v-checkbox v-model="integration.default_for_incidents" label="Default for alerting" dense hide-details />
                <v-checkbox v-model="integration.default_for_deployments" label="Default for deployments tracking" dense hide-details />
                <!-- eslint-enable vue/no-mutating-props -->

                <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text class="my-4">
                    {{error}}
                </v-alert>
                <v-alert v-if="message" color="green" outlined text class="my-4">
                    {{message}}
                </v-alert>
                <div class="d-flex align-center">
                    <v-spacer />
                    <v-btn v-if="value === 'del'" @click="del()" color="error">Delete</v-btn>
                    <template v-else>
                        <v-btn @click="test()" color="secondary" :disabled="!valid" class="mr-4">Send test alert</v-btn>
                        <v-btn @click="save()" color="primary" :disabled="!valid">Save</v-btn>
                    </template>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        value: String,
        integration: Object,
    },

    data() {
        return {
            dialog: !!this.value,
            loading: false,
            error: '',
            message: '',
            valid: false,

            basic_auth: !!this.integration.webhook.basic_auth,
            custom_headers: !!this.integration.webhook.custom_headers,
        };
    },

    watch: {
        dialog(v) {
            this.$emit('input', v ? this.value : '');
        },
        integration: {
            handler() {
                if (!this.integration.webhook.basic_auth) {
                    this.integration.webhook.basic_auth = {user: '', password: ''};
                }
                if (!this.integration.webhook.custom_headers) {
                    this.integration.webhook.custom_headers = [];
                }
            },
            immediate: true,
        },
    },

    methods: {
        save() {
            this.loading = true;
            this.error = '';
            this.message = '';
            if (!this.basic_auth) {
                this.integration.webhook.basic_auth = null;
            }
            if (!this.custom_headers) {
                this.integration.webhook.custom_headers = null;
            }
            this.$api.saveIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = 'Settings were successfully updated.';
                setTimeout(() => {
                    this.message = '';
                    this.dialog = false;
                }, 1000);
            });
        },
        del() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.delIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.dialog = false;
            });
        },
        test() {
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.testIntegration(this.integration, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = 'A test alert has been successfully sent.';
                setTimeout(() => {
                    this.message = '';
                }, 3000);
            });
        },
    },
}
</script>

<style scoped>

</style>